import { useAuthStore } from '@/stores/auth-store';
import { useUIStore } from '@/stores/ui-store';
import { canAccessAdminShell } from '@/lib/roles';

/**
 * Whether the caller may use the storefront inline editor, and whether it is
 * currently switched on.
 *
 * Designers count: inline editing of copy and imagery on the real page is the
 * main reason the role exists. `canEdit` is UX only — every save behind it goes
 * through an admin API route that checks the capability again.
 */
export function useQuickEdit() {
  const user = useAuthStore((s) => s.user);
  const quickEditEnabled = useUIStore((s) => s.quickEditEnabled);
  const canEdit = canAccessAdminShell(user?.role);
  return {
    canEdit,
    /** @deprecated Use `canEdit`. Kept so existing call sites keep compiling. */
    isAdmin: canEdit,
    isActive: canEdit && quickEditEnabled,
  };
}
